var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconfirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1993 7.73112C15.1993 9.49743 13.7668 10.929 11.9993 10.929C10.2319 10.929 8.79935 9.49743 8.79935 7.73112C8.79935 5.9648 10.2319 4.5332 11.9993 4.5332C13.7668 4.5332 15.1993 5.9648 15.1993 7.73112Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3327 19.4568H6.66602C6.66602 18.6994 6.66602 17.9789 6.66602 17.3264C6.66602 15.5591 8.0987 14.127 9.86602 14.127H14.1327C15.9 14.127 17.3327 15.5591 17.3327 17.3264C17.3327 17.9789 17.3327 18.6994 17.3327 19.4568Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconfirst);
export default __webpack_public_path__ + "static/media/ProfileIconfirst.951642dcf966d4ef8257a221b5c5d99c.svg";
export { ForwardRef as ReactComponent };